import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import cx from 'classnames';
import { color as getColor } from '../../../styles/colors';
import styles from './BeatLoader.module.scss';
const BeatLoader = ({ className, size = 15, color = getColor('primary', 30), ...otherProps }) => {
    const itemStyle = {
        width: size,
        height: size,
        backgroundColor: color,
    };
    return (_jsxs("span", { className: cx(styles.beatLoader, className), ...otherProps, children: [_jsx("span", { style: itemStyle }), _jsx("span", { style: itemStyle }), _jsx("span", { style: itemStyle })] }));
};
export default Object.assign(memo(BeatLoader), { displayName: 'BeatLoader' });
